export default __webpack_public_path__ + "static/media/Helm of Ferine Anger.c16864fc.jpg";